import React from "react";

import BaseSvg, { BaseSvgProps } from "../../BaseSvg";

const TransmutationSvg: React.FunctionComponent<BaseSvgProps> = ({
  className = "",
  fillColor,
  secondaryFillColor,
}) => {
  return (
    <BaseSvg className={className} viewBox="0 0 60 60">
      <path
        fill={fillColor}
        d="M44.4 48q-1.5-.4-2.8-.4-1.6 0-1.6-1.5l-.1-2.8c-.1-1.2-.4-4.7-1.6-4.7-1 0-1.2 1.7-1.2 2.2l-.4 5c-.2 1.5-.4 1.7-2 1.8H21.4c-1.7-.1-2-.4-2-2v-8.8q.2-1.4 1.6-1l1 .4c6.6 2 14 0 18.4-5.1 4-4.7 5.6-12.8 1-19C37.8 7 30 3.7 22.4 6.8c-3.9 1.6-7 6.1-6.9 10.2 0 5 3.8 8.5 8.8 8.8q5.3.2 7.8-4.2 1-1.6.5-3.5-.4-1.4-1.8-1.5-1.4 0-1.7 1.3-.3.9-.3 1.9-.1 1.7-1.7 2.3c-2.2 1.2-4.2.5-6-.8-1.7-1.2-2.2-3.5-1.6-5.6a8 8 0 0 1 4.7-5.2q4-1.5 8.1-.1c5.6 1.8 8.7 7.2 7.3 13-2.2 9.2-13.4 12-19.6 7l-1.3-1q-2.3-1.1-3.2 1a11 11 0 0 0-.4 3.4q0 7.4.4 14.8c0 2 .6 2.6 2.7 2.8H21l13.3-.6c1.9 0 2.2.2 2.3 2v2.8q.2 1.6.6 3.2c.2.5.6 1.2 1.1 1.2s1-.7 1.1-1q.4-1.1.5-2.3L40 52c0-1.3.3-1.6 1.7-1.8q1.3-.1 2.5-.5.6-.1.7-1-.1-.5-.7-.7"
      />
    </BaseSvg>
  );
};

export default TransmutationSvg;
